import { useState } from "react";
import {
  LayoutDashboard,
  Users,
  Receipt,
  Menu,
  X,
  CreditCard,
  CalendarDays,
} from "lucide-react";
import "./AdminPage.scss";
import Seo from '../../components/Seo/Seo';
import {
  OverviewSection,
  UsersSection,
  TrainingsSection,
  SubscriptionsSection,
  AccountingSection,
} from "./sections";

const MENU_ITEMS = [
  { key: "overview", label: "Prehľad", icon: LayoutDashboard },
  { key: "users", label: "Správa užívateľov", icon: Users },
  { key: "trainings", label: "Plánovanie tréningov", icon: CalendarDays },
  { key: "subscriptions", label: "Predplatné", icon: CreditCard },
  { key: "accounting", label: "Účtovníctvo", icon: Receipt },
];

function AdminPage() {
  const [activeSection, setActiveSection] = useState("overview");
  const [sidebarOpen, setSidebarOpen] = useState(false);

  const renderContent = () => {
    switch (activeSection) {
      case "overview":
        return <OverviewSection />;
      case "users":
        return <UsersSection />;
      case "trainings":
        return <TrainingsSection />;
      case "subscriptions":
        return <SubscriptionsSection />;
      case "accounting":
        return <AccountingSection />;
      default:
        return <OverviewSection />;
    }
  };

  return (
    <div className="admin">
      <Seo title="Admin" noIndex={true} />
      <button
        className="admin__sidebar-toggle"
        onClick={() => setSidebarOpen(!sidebarOpen)}
        aria-label="Toggle menu"
      >
        {sidebarOpen ? <X size={20} /> : <Menu size={20} />}
        <span>Menu</span>
      </button>

      <aside
        className={`admin__sidebar ${sidebarOpen ? "admin__sidebar--open" : ""}`}
      >
        <nav className="admin__nav">
          <span className="admin__nav-title">Admin Panel</span>
          {MENU_ITEMS.map((item) => {
            const Icon = item.icon;
            return (
              <button
                key={item.key}
                className={`admin__nav-item ${activeSection === item.key ? "admin__nav-item--active" : ""}`}
                onClick={() => {
                  setActiveSection(item.key);
                  setSidebarOpen(false);
                }}
              >
                <Icon size={18} />
                <span>{item.label}</span>
              </button>
            );
          })}
        </nav>
      </aside>

      <div
        className={`admin__sidebar-overlay ${sidebarOpen ? "admin__sidebar-overlay--visible" : ""}`}
        onClick={() => setSidebarOpen(false)}
      />

      <main className="admin__content">{renderContent()}</main>
    </div>
  );
}

export default AdminPage;
